(function($) {
  "use strict";

  var root = this;

  // ask-return modal plugin
  $(function() {
    var modal = document.querySelector("[data-km-role=\"ask-return-modal\"]");

    if (!modal) {
      return; // exit if modal not found
    }

    var modalBody = modal.querySelector(".modal-body"),
      modalFooter = modal.querySelector(".modal-footer"),
      originalBody = modalBody.innerHTML,
      originalFooter = modalFooter.innerHTML;

    // Use event delegation for "No" button
    modal.addEventListener("click", function(event) {
      if (event.target.matches("[data-km-role=\"answer-no\"]")) {
        modalBody.textContent = getTranslation('confirm_delivered_order_no', 'Order not delivered.');
        modalFooter.innerHTML = ''; // Clear existing buttons
        const closeButton = document.createElement('button');
        closeButton.type = 'button';
        closeButton.className = 'btn btn-default';
        closeButton.setAttribute('data-dismiss', 'modal');
        closeButton.textContent = getTranslation('close', 'Close');
        modalFooter.appendChild(closeButton);
      }
    });

    // Reset modal when hidden
    $(modal).on("hidden.bs.modal", function() {
      modalBody.innerHTML = originalBody;
      modalFooter.innerHTML = originalFooter;
    });
  });

}).call(this, jQuery);
